/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Draft_MessagesInputs */



/**
* | output |
* | --- |
* | "Draft an email with me" |
*
* @param {Uno_Welcome_Suggestion_Draft_MessagesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_draft_messages = /** @type {((inputs?: Uno_Welcome_Suggestion_Draft_MessagesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Draft_MessagesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Schreib mit mir eine E-Mail")
	return /** @type {LocalizedString} */ ("Draft an email with me")
});